import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  ref: "modal"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "modal-title" }, [
            _createElementVNode("i", { class: "fas fa-globe" }),
            _createTextVNode(" Máte neuložené změny")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false))
          })
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("p", null, "Zatímco jste byli offline, upravovali jste popis nemovitosti."),
          _createElementVNode("p", null, "Chcete tyto změny uložené ve vašem zařízení nahrát uložit do INEMu?")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sync && _ctx.sync(...args)))
          }, "Uložit do INEMu"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
          }, "Zahodit změny")
        ])
      ])
    ])
  ], 512))
}